module.exports = __webpack_public_path__ + "img/report-en.946a7f0b.png";